



































import { Vue, Component, Prop } from "vue-property-decorator";

// Components
import UpgradeDowngradeForm from "@/components/app/global/contractProducts/upgradeDowngradeForm.vue";

// Types
import { IProduct } from "@/models/products";
import { IContract, IContractProduct } from "@/models/contracts";
import { IInvoice } from "@/models/invoices";

@Component({
  components: {
    "upgrade-downgrade-provider": () =>
      import(
        "@/components/app/global/contractProducts/upgradeDowngradeProvider.vue"
      ),
    "upgrade-downgrade-form": UpgradeDowngradeForm
  }
})
export default class UpgradeDowngradeModal extends Vue {
  // Refs

  public declare $refs: {
    upgradeDowngradeForm: UpgradeDowngradeForm;
  };

  // Props

  @Prop({ required: true })
  public contractProduct!: IContractProduct & { product: IProduct };

  @Prop({ required: true })
  public contract!: IContract;

  @Prop({ required: true })
  public migrationProductId!: IProduct["id"];

  // Data

  public isEnabled = false;
  public isProcessing = false;

  // Methods

  public async validateBeforeSubmit() {
    this.$refs.upgradeDowngradeForm.validateBeforeSubmit();
  }

  public onSuccess(invoice: IInvoice) {
    this.$emit("success", invoice);
    this.$emit("close");
  }
}
